export class Slider{
    constructor() {
        document.querySelectorAll('input[type=range]').forEach(slider => {
            let output = slider.nextElementSibling; // Get the output element

            if (output) {
                switch (output.tagName.toLowerCase()) {
                    case 'input':
                        output.value = slider.value;

                        output.setAttribute('type', 'number');
                        output.setAttribute('min', slider.min); 
                        output.setAttribute('max', slider.max);

                        slider.oninput = function() {
                            output.value = this.value;
                        }

                        output.oninput = function() {
                            slider.value = this.value;
                        }
                    
                    break;
                    default:
                        output.innerHTML = slider.value; // Display the default slider value

                        // Update the current slider value (each time you drag the slider handle)
                        slider.oninput = function() {
                            output.innerHTML = this.value;
                        }
                    break;
                }
            }
        });
    }
}
